import module from 'fanconsultores/module.js'
import template from './template.html'

class FanconsultoresAdminStatusComponent {
  constructor ($state, AppHttpInterceptor) {
    this.$state = $state
    this.AppHttpInterceptor = AppHttpInterceptor
    this.mostrarMas = false
  }

  inicio () {
    this.$state.go('dashboard')
  }

  login () {
    this.AppHttpInterceptor.auth()
  }
}

module.component('fanconsultoresAdminStatus', {
  controller: FanconsultoresAdminStatusComponent,
  template,
  bindings: {
    error: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/fanconsultores/admin/status/component.js